import { SaveParams } from '@ai/api/index.type'

export function resolveAiId(id: SaveParams['id']): string {
  return `ai_${id}`
}

export function open(id: SaveParams['id']): void {
  const _id = resolveAiId(id)

  window.open(`${process.env.AI}#/?id=${id}`, _id)
}

export function resolveAiBannerId(id: SaveParams['id']): string {
  return `ai_banner_${id}`
}

export function openAiBanner(id: SaveParams['id']): void {
  const _id = resolveAiBannerId(id)

  window.open(`${process.env.AI_BANNER}?id=${id}`, _id)
}
